import { useRive } from '@rive-app/react-canvas';
import React from 'react';

import BulbCat from 'Assets/mtm/bulbcat.png';

import RepeatIcon from './repeat0.svg';
import {
  Container,
  TestimonialsWrapper,
  Quote,
  QuoteText,
  BoldText,
  LightText,
  ReplayButton,
  RepeatImage,
  CopyText,
  BulbCatWrapper,
  BoatGuyWrapper,
} from './TestimonialsStyled';

export interface Testimonial {
  background: string;
  textColor: string;
  boldText: string;
  lightText: string;
}

export interface TestimonialsProps {
  testimonials: Testimonial[];
  setShowTestimonials: (show: boolean) => void;
  brand: 'teladoc' | 'talkspace';
  containerStyle?: React.CSSProperties;
  backgroundColor?: string;
}

const SharedTestimonials: React.FC<TestimonialsProps> = ({
  testimonials,
  setShowTestimonials,
  brand,
  containerStyle,
  backgroundColor,
}) => {
  const { RiveComponent } = useRive({
    src: 'https://assets-us-01.kc-usercontent.com/831b591e-b12f-007a-2617-a35180c56dda/a45b4eb0-6db7-48ab-b850-51c0ffeca000/BoatGuy.riv',
    stateMachines: 'sm_default',
    autoplay: true,
    autoBind: true,
  });

  const testId =
    brand === 'talkspace'
      ? 'talkspace-testimonial-component'
      : brand === 'teladoc'
        ? 'teladoc-testimonial-component'
        : undefined;

  return (
    <Container
      brand={brand}
      backgroundColor={backgroundColor || '#fff'}
      style={containerStyle}
      data-testid={testId}
    >
      <TestimonialsWrapper brand={brand}>
        {testimonials.map(({ background, textColor, boldText, lightText }, idx) => (
          <Quote key={idx} background={background}>
            <QuoteText color={textColor}>
              <BoldText>{boldText}</BoldText>
              <LightText>{lightText}</LightText>
            </QuoteText>
          </Quote>
        ))}
      </TestimonialsWrapper>

      <ReplayButton
        brand={brand}
        onClick={() => {
          setShowTestimonials(false);
        }}
      >
        <RepeatImage src={RepeatIcon} alt="Replay" />
        <CopyText>Replay</CopyText>
      </ReplayButton>

      {brand === 'talkspace' && (
        <BoatGuyWrapper>
          <RiveComponent />
        </BoatGuyWrapper>
      )}

      {brand === 'teladoc' && (
        <BulbCatWrapper>
          <img src={BulbCat} alt="character" />
        </BulbCatWrapper>
      )}
    </Container>
  );
};

export default SharedTestimonials;
